// axios
import axios from 'axios'
import Vue from 'vue'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_URL + '/v1/',
  withCredentials: true,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

axiosIns.interceptors.request.use(config => {
  // Do something before request is sent

  const accessToken = localStorage.getItem('token')

  // eslint-disable-next-line no-param-reassign
  if (accessToken) config.headers.common.Authorization = 'Bearer ' + localStorage.getItem('token')

  return config
}, error => Promise.reject(error))

Vue.prototype.$http = axiosIns

export default axiosIns
